/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBedNoteRequest
 */
export interface UpdateBedNoteRequest {
    /**
     * The note to set for the bed
     * @type {string}
     * @memberof UpdateBedNoteRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the UpdateBedNoteRequest interface.
 */
export function instanceOfUpdateBedNoteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "note" in value;

    return isInstance;
}

export function UpdateBedNoteRequestFromJSON(json: any): UpdateBedNoteRequest {
    return UpdateBedNoteRequestFromJSONTyped(json, false);
}

export function UpdateBedNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBedNoteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function UpdateBedNoteRequestToJSON(value?: UpdateBedNoteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
    };
}

